module.exports = __webpack_public_path__ + "static/media/add.24f43569.png";